import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useLoadReservationOffer } from "@/helpers/useLoadReservationOffer.tsx";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useLayoutEffect, useRef } from "react";

export const useReservationOfferURLParam = () => {
  const { handleLoadReservationOffer, reservationOfferLoading } = useLoadReservationOffer();
  const setReservationOfferId = useEngineStore((state) => state.setReservationOfferId);
  const processedOfferRef = useRef<string | null>(null);

  // useLayoutEffect for better recognition
  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const reservationOffer = urlParams.get(URLParam.ReservationOffer);

    if (reservationOffer && processedOfferRef.current !== reservationOffer) {
      processedOfferRef.current = reservationOffer;
      setReservationOfferId(reservationOffer);
      void handleLoadReservationOffer(reservationOffer);
    }

    // eslint-disable-next-line
  }, [window.location.search]);

  return {
    reservationOfferLoading,
  };
};
